/**
 * Feuille « Recalculer » — EF-NAV-006, EF-CAL-002, EF-CAL-005, EF-MOD-002.
 *
 * Elle ne fait qu'une chose : remplacer l'horaire de départ et relancer le
 * calcul. Modifier les vitesses ou les pauses relève de l'onglet Import et
 * paramètres.
 */

import type { JSX } from 'preact';
import { useState } from 'preact/hooks';
import { formatLocalDateTime, parseLocalDateTime } from '../../core/local-datetime';
import { ACTIONS, MARKERS, SHEETS } from '../labels';
import { Sheet } from './Sheet';
import { closeSheet, computeNow, document_, parameters, setParameters } from '../state';

export function RecalcSheet(): JSX.Element {
  const schedule = parameters.value.schedule;
  const [draft, setDraft] = useState(() => formatLocalDateTime(schedule.startLocal).slice(0, 16));
  const parsed = parseLocalDateTime(draft.length === 16 ? `${draft}:00` : draft);

  return (
    <Sheet title={SHEETS.recalc} onClose={closeSheet}>
      <p class="muted">
        Le nouvel horaire de départ remplace l’ancien. Les pauses sont replanifiées à partir de cet
        instant ; le sommeil garde ses heures locales de coucher et de lever.
      </p>

      <label>
        <span class="field-label">Départ, heure locale sans fuseau</span>
        <input
          type="datetime-local"
          step={60}
          value={draft}
          aria-invalid={parsed === null}
          onInput={(event) => {
            setDraft((event.currentTarget as HTMLInputElement).value);
          }}
        />
        {parsed === null ? <span class="field-error">Saisissez une date et une heure valides.</span> : null}
      </label>

      <p class="notice">{MARKERS.timezone}</p>

      <button
        type="button"
        class="primary wide"
        disabled={parsed === null || document_.value === null}
        onClick={() => {
          if (parsed === null) return;
          void setParameters({
            ...parameters.value,
            schedule: { ...parameters.value.schedule, startLocal: parsed },
          }).then(() => computeNow());
        }}
      >
        {ACTIONS.compute}
      </button>
    </Sheet>
  );
}
